import { render, staticRenderFns } from "./InBounds.vue?vue&type=template&id=ec0a0d84&scoped=true&"
import script from "./InBounds.vue?vue&type=script&lang=js&"
export * from "./InBounds.vue?vue&type=script&lang=js&"
import style0 from "./InBounds.vue?vue&type=style&index=0&id=ec0a0d84&scoped=true&lang=scss&"
import style1 from "./InBounds.vue?vue&type=style&index=1&id=ec0a0d84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0a0d84",
  null
  
)

export default component.exports